<template lang="pug">
modal#renotify-pending-bulk-send-modal(
  :no-footer='true'
  :no-header='true'
  ref='modal'
  size='lg'
)
  .d-flex.align-items-start.gap-3
    span.renotify-icon.d-flex.align-items-center.justify-content-center.rounded-circle.flex-shrink-0
      icon(name='arrow-rotate-right')
    .d-flex.flex-column.gap-1.flex-grow-1
      h2.renotify-title.m-0 {{ $t('bulkSendDetails.renotifyPending.title') }}
      p.renotify-description.m-0 {{ $t('bulkSendDetails.renotifyPending.description') }}
    button.renotify-close.btn.btn-link.p-0(
      :aria-label='$t("bulkSendDetails.renotifyPending.close")'
      @click='close'
      type='button'
    )
      icon(name='xmark')

  .renotify-summary.d-flex.justify-content-between.align-items-center.rounded.mt-4.px-3.py-2
    span {{ $t('bulkSendDetails.renotifyPending.willReceive') }}
    span.renotify-summary__total {{ pending }}

  .renotify-footer.d-flex.justify-content-end.gap-2.mt-4
    button.renotify-cancel.btn(@click='close' type='button')
      | {{ $t('bulkSendDetails.renotifyPending.cancel') }}
    button.renotify-confirm.btn.d-flex.align-items-center.gap-2(
      :disabled='loading'
      @click='confirm'
      type='button'
    )
      icon(name='arrow-rotate-right')
      | {{ $t('bulkSendDetails.renotifyPending.confirm', { total: pending }) }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'RenotifyPendingBulkSendModal',
  components: {
    Modal,
    Icon,
  },
  props: {
    pending: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="stylus" scoped>
.renotify-icon
  width: 44px
  height: 44px
  background-color: #E3F0FA
  color: #0A5A8A

.renotify-title
  font-size: 19px
  font-weight: 600
  color: #1F2D2C

.renotify-description
  font-size: 14px
  line-height: 1.55
  color: #3C4A49

.renotify-close
  color: #4F5C5B

.renotify-summary
  font-size: 14px
  color: #0E5F5A
  background-color: #F4FAF9
  border: 1px solid #E4E4E4
  &__total
    font-size: 20px
    font-weight: 600

.renotify-footer
  padding-top: 16px
  border-top: 1px solid #ECECEC

.renotify-cancel
  border: 1.5px solid #0E5F5A
  background-color: #FFFFFF
  color: #0E5F5A
  font-weight: 600
  &:hover
    background-color: #E6F1F0
    color: #0E5F5A

.renotify-confirm
  border: 0
  background-color: #1284C9
  color: #FFFFFF
  font-weight: 500
  &:hover, &:disabled
    background-color: #0F6FA9
    color: #FFFFFF
</style>
